import React from 'react'

export const DownloadButton = ({
  url,
  children,
}: {
  url: string
  children: React.ReactNode
}) => {
  return (
    <a href={url} target="_blank" style={{ textDecoration: 'underline' }}>
      {children}
    </a>
  )
}
